// Tenant-level branding helpers.
// Converts a hex color into the Tailwind/shadcn "H S% L%" tuple used by
// --primary, and applies it (plus foreground) at runtime.

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

function hexToHsl(hex) {
  const h = hex.replace("#", "").trim();
  if (![3, 6].includes(h.length)) return null;
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const r = parseInt(full.slice(0, 2), 16) / 255;
  const g = parseInt(full.slice(2, 4), 16) / 255;
  const b = parseInt(full.slice(4, 6), 16) / 255;
  if ([r, g, b].some((v) => Number.isNaN(v))) return null;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let s = 0, hue = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hue = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hue = (b - r) / d + 2; break;
      case b: hue = (r - g) / d + 4; break;
      default: break;
    }
    hue *= 60;
  }
  return { h: Math.round(hue), s: Math.round(s * 100), l: Math.round(l * 100) };
}

// Return "#000000" or "#FFFFFF" so text on the brand color stays readable.
function readableForeground(hsl) {
  return hsl.l > 60 ? "0 0% 10%" : "0 0% 100%";
}

const DEFAULT_KEYS = ["--primary", "--primary-foreground", "--ring"];

export function applyBrandColor(hex) {
  try {
    const hsl = hex ? hexToHsl(hex) : null;
    const root = document.documentElement;
    if (!hsl) {
      // Reset to whatever the stylesheet defines (remove inline overrides).
      DEFAULT_KEYS.forEach((k) => root.style.removeProperty(k));
      return;
    }
    const primary = `${hsl.h} ${clamp(hsl.s, 15, 90)}% ${clamp(hsl.l, 15, 60)}%`;
    root.style.setProperty("--primary", primary);
    root.style.setProperty("--primary-foreground", readableForeground(hsl));
    root.style.setProperty("--ring", primary);
  } catch (_) { /* webviews com CSP agressivo podem bloquear style.setProperty */ }
}

export function rememberLastTenantSlug(slug) {
  if (!slug) return;
  try { localStorage.setItem("last_tenant_slug", slug); } catch {}
}

export function getLastTenantSlug() {
  try { return localStorage.getItem("last_tenant_slug") || ""; } catch { return ""; }
}
